<template>
  <div>
    <div style="display: flex; align-items: center; justify-content: center; padding: 50px 0px 50px 0px">      
    </div>
     <!-- iPhone / iPad -->
      <div v-if="isIos">
        <v-row v-for="rule in reglamentos" :key="rule.id" align="center" class="mb-3">
          <v-col cols="10">
            <v-btn
              block
              color="blue"
              style="color:white"
              large
              rounded
              target="_blank"
              :href="rule.pdfName"
            >
              {{ rule.title }}
            </v-btn>
          </v-col>
          <!-- Descargar -->
          <v-col cols="2">
            <v-btn  
              large icon         
              style="background-color:#0C3DB3"
              @click="downloadPdf(rule.pdfName)"
            >
              <v-icon 
                  block color="white"                                    
                  medium rounded 
                  >
                  mdi-download
              </v-icon>
            </v-btn>
          </v-col>         
        </v-row>
      </div>

      <!-- Otros dispositivos -->
      <v-col v-else v-for="rule in reglamentos" :key="rule.id" cols="12">
        <v-btn
          block
          color="blue"
          style="color:white"
          large
          rounded
          target="_blank"
          :href="rule.pdfName"
        >
          {{ rule.title }}
        </v-btn>
      </v-col>

      <v-col cols="12">
        <v-btn
          block
          color="blue"
          rounded
          outlined
          link
          to="/regulations"
        >
          Regresar
        </v-btn>
      </v-col>   
  </div>
</template>

<script>
import adminRuleService from '@/services/admin/rules';

export default {
  data() {
    return {          
      isIos: false,
      reglamentos: [],
      rules: [],
    };
  },
  created() {
    this.getRules();   
    const userAgent = window.navigator.userAgent.toLowerCase();
    this.isIos = /iphone|ipad|ipod/.test(userAgent);
    this.isIos = true;
  },
  methods: {
    getRules() {
      adminRuleService.fetch().then((response) => {
        this.rules = response.data;       
        this.reglamentos = this.rules.filter( r =>  r.kind == 'Asambleas' );   
      });
    },
    async downloadPdf(url) {
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = 'regla_de_uso.pdf';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    },
  },  
};
</script>

<style lang="scss" scoped>
@import './src/assets/style.scss';
</style>



